import { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { API_URL } from "../utils/utils";

// Helper function to initialize feather icons
const initFeatherIcons = () => {
  if (window.feather) {
    window.feather.replace();
  } else {
    setTimeout(initFeatherIcons, 100);
  }
};

export default function Dashboard() {
  const { user } = useAuth();
  const [dashboardData, setDashboardData] = useState({
    total_bookings: 0,
    total_revenue: 0,
    total_distance: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
    const timer = setTimeout(() => {
      initFeatherIcons();
    }, 500);
    return () => clearTimeout(timer);
  }, [user]);

  const fetchDashboardData = async () => {
    if (!user || !user.id) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(
        `${API_URL}get_passenger_dashboard/${user.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.ok) {
        const result = await response.json();
        console.log(result)
        if (result.status === "success" && result.data) {
          setDashboardData({
            total_bookings: result.data.total_bookings || 0,
            total_revenue: result.data.total_revenue || 0,
            total_distance: result.data.total_distance || 0,
          });
        }
      } else if (response.status === 403) {
        console.error("Access forbidden - user may not be authenticated");
        // Don't show error to user, just log it
      } else {
        console.error("Failed to fetch dashboard data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return `£${parseFloat(amount || 0).toFixed(2)}`;
  };

  const formatDistance = (distance) => {
    return `${parseFloat(distance || 0).toFixed(2)} miles`;
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap grid-margin">
        <div>
          <h4
            className="mb-3 mb-md-0"
            style={{ color: "#d70015" }}
          >
            Welcome to your Dashboard
          </h4>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-xl-12 stretch-card">
          <div className="row flex-grow-1">
            {/* Total Bookings Card */}
            <div className="col-md-4 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-baseline">
                    <h6 className="card-title mb-0">Total Bookings</h6>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <h3 className="mb-2" style={{ color: "#d70015" }}>{dashboardData.total_bookings}</h3>
                      <p className="text-muted mb-0">All time bookings</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Total Revenue Card */}
            <div className="col-md-4 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-baseline">
                    <h6 className="card-title mb-0">Total Revenue</h6>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <h3 className="mb-2" style={{ color: "#d70015" }}>{formatCurrency(dashboardData.total_revenue)}</h3>
                      <p className="text-muted mb-0">Total amount spent</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Total Distance Card */}
            <div className="col-md-4 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-baseline">
                    <h6 className="card-title mb-0">Total Distance</h6>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <h3 className="mb-2" style={{ color: "#d70015" }}>{formatDistance(dashboardData.total_distance)}</h3>
                      <p className="text-muted mb-0">Total distance traveled</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
